import React from "react";

import { getCategories } from "lib/product";
import Catalog from "../catalogue";

export default function SubcategoryPage({ category, categories, catalogName }) {
  return <Catalog category={category} categories={categories} catalogName={catalogName} />;
}

export async function getStaticProps(context) {
  const categories = await getCategories();
  const formattedCategories = categories.map((category) => ({
    ...category,
    ...{ subcategories1: null, subcategories2: null },
  }));
  const catalogName = process.env.ALGOLIA_CATALOG_NAME;
  const category = categories.find((cat) => cat.slug === context.params.category)?.name.toLowerCase();
  if (!category) {
    return {
      notFound: true,
      revalidate: 30,
    };
  }
  return {
    props: {
      category,
      categories: formattedCategories,
      catalogName: catalogName,
    },
    revalidate: 30,
  };
}

export async function getStaticPaths() {
  const paths = [];
  return {
    paths,
    fallback: "blocking",
  };
}
